import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HomeCategories from './components/HomeCategories';
import HomeArticles from './components/HomeArticles';
import HomeFAQ from './components/HomeFAQ';
import HomeContact from './components/HomeContact';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '蜜芽永不失联',
  url: 'https://miya-official.com',
  description:
    '蜜芽永不失联，为您整合蜜芽最新官方联系方式、客服入口、订单查询及社群渠道，确保每位用户随时都能找到蜜芽、获取售后支持与促销资讯。',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://miya-official.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '蜜芽的客服电话是多少？服务时间是什么时候？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '蜜芽全国统一客服热线为400-xxx-xxxx，服务时间为周一至周日9:00-21:00。建议在拨打电话前准备好您的订单号，以便客服人员快速为您查询。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在蜜芽查询我的订单物流信息？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '打开蜜芽APP，进入"我的"→"我的订单"，找到对应订单后点击"查看物流"即可查看详细物流轨迹。',
      },
    },
    {
      '@type': 'Question',
      name: '蜜芽支持哪些支付方式？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '蜜芽支持微信支付、支付宝、储蓄卡、信用卡以及蜜芽余额等多种支付方式。',
      },
    },
    {
      '@type': 'Question',
      name: '蜜芽的退换货政策是怎样的？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '蜜芽支持7天无理由退货（需保持商品原状），质量问题支持15天内换货或退货。退货流程在APP内"我的订单"中申请售后。',
      },
    },
    {
      '@type': 'Question',
      name: '如何加入蜜芽官方社群获取最新资讯？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '添加蜜芽小助手微信号"miya_official"加入官方微信群；关注小红书"蜜芽Miya"、抖音"蜜芽"、微博"蜜芽官方微博"等社交账号。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />

      <div className="min-h-screen bg-white">
        <Navbar />

        <main>
          <header className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20soft%20and%20elegant%20website%20hero%20background%20with%20abstract%20organic%20shapes%20in%20warm%20peach%20and%20cream%20tones%2C%20gentle%20gradient%20from%20light%20pink%20to%20warm%20beige%2C%20minimalist%20and%20calm%20atmosphere%2C%20clean%20modern%20design%20with%20subtle%20texture%2C%20soft%20diffused%20lighting%2C%20no%20text%20or%20people%2C%20abstract%20geometric%20composition&width=1800&height=1200&seq=hero-miya-2026&orientation=landscape"
              alt="蜜芽永不失联"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>
            <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 w-full">
              <h1
                className="text-3xl md:text-5xl font-bold text-white mb-4"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                蜜芽永不失联
              </h1>
              <p className="text-sm md:text-lg text-white/90 max-w-lg leading-relaxed">
                为您整合蜜芽最新官方联系方式、客服入口、订单查询及社群渠道，确保每位用户随时都能找到蜜芽、获取售后支持与促销资讯，再也不怕失去联系。
              </p>
              <div className="flex flex-col sm:flex-row gap-3 mt-8">
                <a
                  href="#contact"
                  className="px-6 py-2.5 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  联系我们
                </a>
                <a
                  href="#articles"
                  className="px-6 py-2.5 bg-white/20 text-white border border-white/40 rounded-md text-sm font-medium hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
                >
                  查看最新动态
                </a>
              </div>
            </div>
          </header>

          <HomeCategories />
          <div id="articles">
            <HomeArticles />
          </div>
          <HomeFAQ />
          <HomeContact />
        </main>

        <Footer />
      </div>
    </>
  );
}